import * as React from 'react';
import * as styles from '../styles.scss';
import { Fallback, PriceInput } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import { FormikErrors } from 'formik';
import { OrderKind, OrderType } from 'constants/enum';
import { INewSymbolData } from 'interfaces/market';

interface IPriceSectionProps
  extends React.ClassAttributes<PriceComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly values: IOrderForm;
  readonly symbol?: INewSymbolData;
  readonly orderKind: OrderKind;
  readonly isHorizontal: boolean;
  readonly onChangePrice: (orderPrice?: number) => void;
  readonly onBlurPrice: (priceStep?: number) => void;
  readonly onChangeOrderType: (orderType: OrderType) => void;

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class PriceComponent extends React.Component<IPriceSectionProps> {
  render() {
    const {
      t,
      config,
      ErrorMessage,
      errors,
      values,
      symbol,
      isHorizontal,
      orderKind,
      onChangeOrderType,
      onChangePrice,
      onBlurPrice,
    } = this.props;
    return (
      <div
        className={classNames(styles.PriceSection, styles.FormField)}
        style={config[OrderFormFieldKey.PRICE]?.style}
      >
        <div className={styles.MainField}>
          <div className={styles.FieldTitle}>{t('Price')}</div>
          <div className={classNames(styles.FieldInput, styles.MarginTop16)}>
            <PriceInput
              type="price"
              sellBuyType={values.sellBuyType}
              data={symbol}
              onChange={onChangePrice}
              onBlur={onBlurPrice}
              onChangeOrderType={onChangeOrderType}
              value={values.orderPrice}
              error={errors.orderPrice != null}
              orderType={values.orderType}
              orderKind={orderKind}
              position={isHorizontal ? 'top' : 'bottom'}
            />
          </div>
        </div>

        <ErrorMessage message={errors.orderPrice} />
      </div>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const PriceSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(PriceComponent)
  ),
  Fallback,
  handleError
);

export default PriceSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/Price.tsx